export { default as createTablePlugin } from './createTablePlugin';
export { default as withTable } from './withTable';
